import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-checkbox',
  template: `
    <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white" *ngIf="to.label">{{ to.label }}</label>
    <div class="flex items-center pl-4 border border-gray-200 rounded dark:border-gray-700">
        <input id="checkbox" type="checkbox" [formControl]="formControl" [formlyAttributes]="field" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
        <label *ngIf="to.placeholder" for="checkbox" class="w-full py-2.5 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{ to.placeholder }}</label>
    </div>
  `,
})
export class CheckboxFieldType extends FieldType<FieldTypeConfig> {}
